import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../api/index.js';
import { notification } from 'antd';

export const startLinkCalendarFlow = createAsyncThunk(
    'googleCalendar/startLinkCalendarFlow',
    async (_, { rejectWithValue }) => {
        try {
            const url = await API.linkedGoogleCalendar.getAuthUrl();
            return url;
        } catch (err) {
            notification.error({
                message: 'Error',
                description: err.message || 'Failed to start Google Calendar linking flow',
            });
            return rejectWithValue(err.message);
        }
    },
);

export const fetchLinkedCalendars = createAsyncThunk(
    'googleCalendar/fetchLinkedCalendars',
    async (_, { rejectWithValue }) => {
        try {
            const calendars = await API.linkedGoogleCalendar.getLinkedCalendars();

            return calendars || [];
        } catch (err) {
            notification.error({
                message: 'Error',
                description: err.message || 'Failed to load linked calendars',
            });
            return rejectWithValue(err.message);
        }
    },
);

export const unlinkCalendar = createAsyncThunk(
    'googleCalendar/unlinkCalendar',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            await API.linkedGoogleCalendar.removeLinkedCalendar(id);
            notification.success({
                message: 'Success',
                description: 'Calendar disconnected',
            });
            dispatch(fetchLinkedCalendars());
            return { id };
        } catch (err) {
            notification.error({
                message: err.type || 'Error',
                description: err.message || 'Failed to unlink calendar',
            });
            return rejectWithValue(err.message);
        }
    },
);
